import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import classnames from "classnames";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import DownArrow from "/static/svg/arrow-down.svg";
import { isDarkTheme } from "segments/segments-service";
import { StyledFaqQuestion } from "./faq-question.scss";
const FaqQuestion = (props)=>{
    const itemRef = useRef(null);
    const { question, isOpen, answerId, questionId, index, translate, faqQuestionClickedCallback, questionSize, theme } = props;
    const itemClicked = ()=>{
        faqQuestionClickedCallback(index);
    };
    const removeFocusOnMouseLeave = ()=>{
        var _itemRef_current;
        itemRef === null || itemRef === void 0 ? void 0 : (_itemRef_current = itemRef.current) === null || _itemRef_current === void 0 ? void 0 : _itemRef_current.blur();
    };
    const keyDownHandler = generateOnKeyDownHandler(itemClicked);
    return /*#__PURE__*/ _jsx(StyledFaqQuestion, {
        className: "faq-question",
        onClick: itemClicked,
        onMouseLeave: removeFocusOnMouseLeave,
        "aria-expanded": isOpen,
        role: "button",
        onKeyDown: keyDownHandler,
        tabIndex: 0,
        "aria-controls": answerId,
        ref: itemRef,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "faq-question-item",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("faq-question-text", questionSize),
                    id: questionId,
                    children: translate(question)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("down-arrow-wrapper", {
                        open: isOpen
                    }),
                    "aria-hidden": true,
                    children: /*#__PURE__*/ _jsx(DownArrow, {
                        className: classnames("down-arrow", {
                            white: isDarkTheme(theme)
                        })
                    })
                })
            ]
        }, index)
    });
};
export default withGenericConfig(FaqQuestion);
